import { Directive, ElementRef, Input, OnChanges, Renderer2, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appRichText]',
  standalone: true
})
export class RichTextDirective implements OnChanges {
  @Input('appRichText') private value: string;
  private addQlEditorClass: boolean;

  constructor(
    private renderer: Renderer2,
    private hostElement: ElementRef
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    for (const propName in changes) {
      if (propName === 'value') {
        this.addQlEditorClass = this.value.startsWith('<');

        if (this.addQlEditorClass) {
          this.hostElement.nativeElement.classList.add('rendered-quill-content', 'ql-editor');
        }

        this.renderer.setProperty(this.hostElement.nativeElement, 'innerHTML', this.value);
      }
    }
  }
}
